import React from 'react';
import { getResponsiveMarginClassesFromStyleOverride } from '@/helpers/addResponsiveSpacingOverrides';
import { StyleOverride } from '@/types/craft-style-overrides';

interface SectionWrapperProps {
  styleOverrides?: StyleOverride;
  className?: string;
  children: React.ReactNode;
}

const SectionWrapper: React.FC<SectionWrapperProps> = ({ styleOverrides, className, children }) => {
  const sectionMarginOverrides = getResponsiveMarginClassesFromStyleOverride(styleOverrides);
  const sectionMargins: string | undefined = sectionMarginOverrides || className;

  if (!sectionMargins) {
    return children;
  }

  return <div className={sectionMargins}>{children}</div>;
};

export default SectionWrapper;
